/**
 * GlobalConfirmDialog — app-level mount of `<ConfirmDialog>` driven by
 * `useConfirmDialogStore`. Replaces inline AlertDialog rendering inside other
 * Dialogs (Settings, MetaInfo manager, etc.) so we never stack a Radix
 * AlertDialog inside an open Radix Dialog — see the store header comment.
 */

import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useConfirmDialogStore } from './confirmDialogStore';

export function GlobalConfirmDialog() {
  const isOpen = useConfirmDialogStore((s) => s.isOpen);
  const request = useConfirmDialogStore((s) => s.request);
  const closeConfirm = useConfirmDialogStore((s) => s.closeConfirm);

  if (!request) return null;

  return (
    <ConfirmDialog
      open={isOpen}
      onOpenChange={(next) => {
        if (!next) closeConfirm();
      }}
      title={request.title}
      description={request.description}
      confirmLabel={request.confirmLabel}
      cancelLabel={request.cancelLabel}
      variant={request.variant}
      requireTypedName={request.requireTypedName}
      onConfirm={async () => {
        await request.onConfirm();
      }}
      onError={request.onError}
      // Prevent Radix from focusing back to the (possibly-removed) trigger
      // element when this AlertDialog closes. The trigger lives inside a
      // surrounding Radix Dialog (e.g. Settings) and a stray focus-fallthrough
      // would cause that Dialog to auto-close as if the user had clicked
      // outside it.
      preventCloseAutoFocus
    />
  );
}
